import styled from 'styled-components';

export default styled.div`
	.motif-accordion-title-content {
		flex: 1;
		min-width: 0;
	}

	.motif-accordion-content {
		--accordion-padding-v: var(--spacing-large);
		--accordion-padding-h: var(--spacing-xx-large);
		padding: 0;
	}
`;
